import { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';

import { sliderData } from '../../data/sliderData'; // Adjust the import path as necessary

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

import './Slider.css';

const Slider = () => {
  const [swiperInstance, setSwiperInstance] = useState<any>(null);

  useEffect(() => {
    if (swiperInstance) {
      swiperInstance.navigation.init();
      swiperInstance.navigation.update();
    }
  }, [swiperInstance]);

  return (
    <div className="slider-wrapper">
      <Swiper
        onSwiper={setSwiperInstance}
        modules={[Navigation, Pagination, Autoplay, EffectFade]}
        spaceBetween={30}
        slidesPerView={1}
        lazyPreloadPrevNext={1}
        navigation={{
          prevEl: '.swiper-button-prev',
          nextEl: '.swiper-button-next',
        }}
        pagination={{ clickable: true }}
        loop={true}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        effect="fade"
      >
        {sliderData.map(({ src, label }, index) => (
          <SwiperSlide key={index}>
            <div className="slider-slide-container">
              <img
                src={`/images/slider/${src}`}
                alt={label}
                className="img-fluid swiper-lazy"
              />
              {index === 0 ? (
                <div className="slider-slide-text-community-name">
                  <h1>{label}</h1>
                </div>
              ) : (
                <div className="slider-slide-text">{label}</div>
              )}
            </div>
          </SwiperSlide>
        ))}

        <div className="swiper-button-prev">
          <FontAwesomeIcon icon={faArrowLeft} />
        </div>
        <div className="swiper-button-next">
          <FontAwesomeIcon icon={faArrowRight} />
        </div>
      </Swiper>
    </div>
  );
};

export default Slider;
